import React, { useEffect, useState } from "react";
import {
  Box,
  DynamicButton,
  MainHolder,
  StyledText,
} from "../../../../components/common";
import styled from "styled-components";
import {
  NewBackButton,
  NoticeIcon,
  TrophyIcon,
} from "../../../../components/svgs";
import useTimer from "../../../../hooks/useTimer";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { useTheme } from "../../../../hooks";
import GetPinCard from "../components/getPinCard";
import CarouselTimer from "../components/carouselTimer";
import useCountDown from "../hooks/timer";
import { io } from "socket.io-client";
import useFastestFinger from "../../../../hooks/useFastestFinger";


const FastestFingerHome = () => {
  const { themeContext, theme } = useTheme();
  let mashupBackground =
    theme.colors[themeContext.activeTheme]["mashupBackground"];
  let themeColor = "background";
  let background = theme.colors[themeContext.activeTheme][themeColor];
  const {
    fastestFingerData,
    getFastestFinger,
    startGame,
    gameStatus,
    getGameStatus,
    setFastestFingerData,
  } = useFastestFinger();
  const { timeRemaining = 0 } = fastestFingerData || {}

  const [inGameCountDown, setInGameCountDown] = useState(new Date());
  const [pinCountDown, setPinCountDown] = useState(new Date());
  const [startFastestFinger, setStartFastestFinger] = useState(false);
  const [showPinCode, setShowPinCode] = useState(false);
  const [socketConnection, setSocketConnection] = useState(null);
  const [socketMessage, setSocketMessage] = useState(null);

  const { isCompleted, minutes, seconds } = useCountDown(inGameCountDown);
  const {
    isCompleted: pinExpiryIsCompleted,
    minutes: pinExpiryMinutes,
    seconds: pinExpirySeconds,
  } = useCountDown(pinCountDown);

  let history = useHistory();

  const handleFastestFingerEvent = (msg) => {
    if (!msg) return;
    setSocketMessage(msg);
    if (!msg?.isFinal) {
      const {
        isWaiting,
        waitingEndTime,
        pinExpiryEndTime,
      } = msg || {}
      if (isWaiting) {
        setInGameCountDown(waitingEndTime);
      } else {
        setPinCountDown(pinExpiryEndTime);
      }
    } else {
      setFastestFingerData(null);
      history.push('/fastest_finger/game_status')
    }
  }

  useEffect(() => {
    if (isCompleted && !socketMessage && startFastestFinger) startGame();
  }, [isCompleted, startFastestFinger]);

  useEffect(() => {
    getGameStatus();
    getFastestFinger();
    // Connect to socket
    const socket = io(process.env.REACT_APP_WEBSOCKET_URL, {
      transports: ["polling"],
    });
    socket.on("connect", () => {
      console.log("Connected");
    });

    socket.on("connect_error", (msg) => {
      console.log("Could not connect to socket")
      setTimeout(() => {
        socket.connect();
      }, 1000);
    });
    setSocketConnection(socket);

    return () => {
      socket.disconnect();
    };
  }, []);

  useEffect(() => {
    socketConnection?.on("fastestFinger", (msg) => {
      setShowPinCode(false);
      handleFastestFingerEvent(msg);
    });
  }, [socketConnection]);

  useEffect(() => {
    if (gameStatus && !socketMessage) {
      const { isWaiting, waitingEndTime, pinExpiryEndTime, quantityRemaining } = gameStatus;
      const timeLeft = new Date(isWaiting ? waitingEndTime : pinExpiryEndTime) - new Date();
      const MINIMUM_TIME_THRESHOLD = 8;

      if (timeLeft / 1000 > MINIMUM_TIME_THRESHOLD) {
        handleFastestFingerEvent(gameStatus);
      }
    }
  }, [socketMessage, gameStatus, timeRemaining]);

  return (
    <>
      {startFastestFinger ? (
        <MainHolder
          style={{
            display: "flex",
            flex: 1,
            flexDirection: "column",
          }}
        >
          <Box
            style={{
              display: "flex",
              alignItems: "center",
              backgroundColor: isCompleted ? "#0FAF4B" : "#EE2737",
              paddingLeft: 15,
              paddingTop: 5,
              paddingBottom: 5,
            }}
          >
            <div style={{ position: "absolute" }}>
              <BackButtonContainer
                onClick={() => {
                  history.goBack();
                }}
              >
                <NewBackButton />
              </BackButtonContainer>
            </div>
            <Box
              style={{
                display: "flex",
                flex: 1,
                backgroundColor: isCompleted ? "#0FAF4B" : "#EE2737",
                justifyContent: "center",
              }}
            >
              <StyledText style={{ fontSize: 18, color: "white" }}>
                {isCompleted
                  ? (!!socketMessage ? "PIN is ready for grabs!" : "Connecting...")
                  : `Next PIN ready in ${minutes}:${seconds}`}
              </StyledText>
            </Box>
          </Box>
          <div
            style={{
              width: "80%",
              display: "flex",
              flexDirection: "column",
              alignSelf: "center",
            }}
          >
            <StyledText>Fastest fingers</StyledText>
            <StyledText
              style={{ textAlign: "center", fontFamily: "MTNRegular" }}
            >
              Redeem PIN by copying the code and recharging with
              <span style={{ fontFamily: "MTNBold" }}> *134*PIN# </span>on your
              phone
            </StyledText>
            <ScratchCardContainer>
              {showPinCode ? (
                <GetPinCard
                  scratchCardCode={socketMessage?.pin || ''}
                  quantity={socketMessage?.quantityRemaining}
                />
              ) : (
                <>
                  <div style={{ display: "flex", justifyContent: "center" }}>
                    <StyledText>GHs 10 Airtime</StyledText>
                  </div>

                  <DynamicButton
                    label={"Get PIN"}
                    color={background}
                    width={200}
                    onClick={() => setShowPinCode(true)}
                    disabled={!isCompleted || socketMessage?.isWaiting || !socketMessage}
                  />
                  <div style={{ display: "flex", justifyContent: "center" }}>
                    <StyledText
                      style={{ fontFamily: "MTNRegular", fontSize: 12, color: "#7F7F7F" }}
                    >
                      {
                        socketMessage && <>
                          {socketMessage?.quantityRemaining || 0} pin{socketMessage?.quantityRemaining < 2 ? "" : "s"} remaining
                        </>
                      }
                    </StyledText>
                  </div>
                </>

              )}
            </ScratchCardContainer>

            {showPinCode && (
              <ExpireNoticeContainer>
                <NoticeIcon
                  width={15}
                  fill="black"
                  style={{ marginRight: 5 }}
                />
                <StyledText
                  style={{
                    fontFamily: "MTNRegular",
                    fontSize: 12,
                    margin: 0,
                  }}
                >
                  PIN Expires in {pinExpirySeconds} seconds
                </StyledText>
              </ExpireNoticeContainer>
            )}
          </div>
        </MainHolder>
      ) : (
        <CarouselTimer
          timeRemaining={timeRemaining + 5000}
          onHandleIsTime={(isTime) => setStartFastestFinger(isTime)}
        />
      )}
    </>
  );
};

export default FastestFingerHome;

const BackButtonContainer = styled.div`
  background-color: #ffcc00;
  width: 30px;
  height: 30px;
  border-radius: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ScratchCardContainer = styled.div`
  width: 80%;
  background-color: white;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  margin: 20px;
  padding: 15px;
  overflow: auto;
`;

const ExpireNoticeContainer = styled.div`
  display: flex;
  align-items: center;
  align-self: center;
`;
